module.exports = __webpack_public_path__ + "media/section1MVideo.d966bf22.mp4";